import { useEffect, useMemo, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";
import { ComplianceQueryItemTypes } from "src/modules/3rd-party-management/constants";

const FilteringComponent = ({
    onChange
}) => {
    const [tableFilters, setTableFilters] = useState({
        fullName: null,
        type: null
    });

    const initRef = useRef(false);

    const tableFilterTabs = useMemo(() => {
        const types = ComplianceQueryItemTypes.map((queryType) => {
            return {
                id: queryType.value,
                name: queryType.label
            }
        });

        let filtersList = [
            {
                type: 'radio_list',
                name: 'type',
                title: 'Type',
                icon: <i className="ri-filter-3-line" />,
                isLoading: false,
                defaultValue: tableFilters.type,
                data: types,
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.name
                }
            },
            {
                type: 'search_textbox',
                name: 'fullName',
                title: 'Enter name or keyword',
                icon: <i className="ri-search-2-line" />,
                defaultValue: tableFilters?.fullName,
                options: {
                    placeholder: 'Search',
                    typingDelay: 750
                },
                displayIndependently: true,
                onFilterChange: (value) => {
                    if (value !== tableFilters.fullName) {
                        setTableFilters((currentState) => ({ ...currentState, fullName: value }))
                    }
                }
            }
        ];

        return filtersList
    }, [
        tableFilters
    ]);

    const onTableFilterOkButtonClicked = (filters, independentTabsData) => {
        if (filters) {
            const result = {}

            if ('type' in filters) {
                result.type = filters.type !== 'all' ? filters.type : undefined
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                type: null,
                fullName: independentTabsData?.fullName
            })
        }
    }

    useEffect(() => {
        if (!initRef.current) {
            initRef.current = true;
            return;
        }

        onChange && onChange(tableFilters)
    }, [
        tableFilters,
        onChange
    ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='type'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent);
